
class activityBuilderContent {

	constructor(activityBuilderObj)
		{
			this.activityBuilderObject = JSON.parse(activityBuilderObj);
		}
		
}

export default activityBuilderContent;